import $ from 'jquery';

import constants from 'Constants.js';
import BaseTableView from 'properties/BaseTableView.js'
import {View} from 'backbone';

import rolesTemplate from '../../../../../templates/workflow/properties/roles/roles.ejs';
import EditRolesView from 'common-views/EditRolesView';
import listService from 'ListService.js';
import eventBus from 'EventBus.js';
import sequenceService from 'SequenceService.js';
import util from 'util/Util';


class RolesView extends BaseTableView {

  initialize(opts) {

    this.options = opts || {};
    this.template = rolesTemplate;
    this.tagName = 'div';
    this.id = opts.el;
    this.gridEl = constants.PROP_MAIN_TABLE;


    this.events = {
      "click .itemNew": "itemNew",
      "click .itemRemove": "itemRemove",
      "click .itemEdit": "itemEdit",
      "click .itemUp": "itemUp",
      "click .itemDown": "itemDown",
      "change input[type=checkbox]": "itemCheck"
    };

    this.refreshGridData();


    this.model.set({
      colModel: [
        {
          name: 'name',
          index: 'name',
          editable: true,
          width: 100 //PF-PF-1763 - Workflow - Roles - 2.Also, in IE, changing name of a role with double-click is not working unless the click is made in the top left corner as in the attached file. 
        },
        {
          name: 'defaultPerson',
          index: 'defaultPerson',
          editable: false
        }

      ],
      colNames: ['Name', 'Default Person']
    }, {silent: true});

    this.listenTo(this.model, 'change', this.render);
    this.listenTo(eventBus, constants.EV_ROLE_OR_STAGE_UPDATED, () => {
      this.refreshGridData();
      this.render();
    });

    this.onResize();
    return this;
  }

  refreshGridData() {
    const defaultGrid = listService.getWorkflowRoles();

    this.model.set('gridData', defaultGrid.toArray());
    util.setGridScrollPos(this.model);
  }

  // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
  onResize() {
    $(window).on('resize', () => {
      this.resizeGrid();
    })
  }

  itemEdit() {
    util.saveGridScrollPos(this.model);
    const row = this.model.get('rowid');
    if (row) {
      const view = new EditRolesView({model: this.model});
      view.render();
    }
  }

  itemCheck(e) {
    util.saveGridScrollPos(this.model);
    var i = $(e.currentTarget).closest('tr').index() - 1;
    var gridData = this.model.get('gridData');

    if (e.currentTarget.checked) {
      gridData[i].formula = 'formula';
    }
    else {
      gridData[i].formula = '';
    }

    this.model.set('gridData', gridData, {silent: true});
    this.model.trigger('change');
  }

  itemNew() {
    this.model.set('newRowAdded', true, constants.MODEL_SILENT);
    util.saveGridScrollPos(this.model);
    
    var gridData = this.model.get('gridData');
    var newRow = {
      'name': 'Role ' + (gridData.length + 1),
      'defaultPerson': '',
      'userRoleType': ''
    };
    newRow.id = sequenceService.nextDomId();
    listService.addWorkflowRole(newRow);
    $(this.gridEl).addRowData((gridData.length + 1), newRow);
    gridData.push(newRow);
    this.model.set('gridData', gridData);

    super.render();

  }

  itemRemove() {
    let gridData = this.model.get('gridData');
    if (gridData.length > 0) {
      let rowid = this.model.get('rowid') ? this.model.get('rowid') : undefined;
      if (!rowid) {
        rowid = gridData.length - 1;
      }

      let data = { id: gridData[rowid].id };
      listService.deleteWorkflowRole(data);
      super.itemRemove();
    }
  }

  setRow(rowId, e) {
    this.model.set({
      rowid: rowId
    }, {silent: true});
    $(`#${e.currentTarget.id}`).jqGrid('setSelection', rowId);
  }

  afterEditCell(rowId, cellName, value, iRow, iCol) {
    let self = this;
    $("#" + iRow + "_" + cellName).bind('blur', function () {
      $(self.gridEl).saveCell(iRow, iCol);
    });
  }

  remove() {
    $(window).off('resize');
    super.remove();
  }
}

export default RolesView;
